import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./ComplianceModalTable.scss";
import Check from "../../images/table_check.svg";
import Warningsign from "../../images/Warning.png";
import { CSVLink } from "react-csv";
import CSVImage from "../../images/csv-file.png";
import {
  getCompliancebyUser,
} from "../../util/API/Compliance";

export default function ComplianceModalTable({
  setSelectedData,
  setfullSelectedData,
  fullSelectedData,
  selectedData,
  resetPreviousTransactions,
  view,
}) {
  const [open, setOpen] = useState(false);
  const [sorting, setSorting] = useState({
    column: "",
    direction: "asc",
  });
  const [loading, setLoading] = useState(true);
  const [transactionAuditData, setTransactionAuditData] = useState([]);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    //Get the data for all of the transactions and the params for the different types of transactions
    const getData = async () => {
      resetPreviousTransactions();
      let amlRuleDesc = fullSelectedData.amruledesc;
      let amlRule = fullSelectedData.amlrule;
      let transactionAuditData;
      let senderFirstName = selectedData.senderFirstName;
      let senderLastname = selectedData.senderLastname;
      let receiverFirstName = selectedData.receiverFirstName;
      let receiverLastName = selectedData.receiverLastName;
      let manyToOneParam = `${receiverFirstName}/${receiverLastName}`;
      let oneToManyParam = `${senderFirstName}/${senderLastname}`;
      let flippingParam = `${senderFirstName}/${senderLastname}/${receiverFirstName}/${receiverLastName}`;

      transactionAuditData = await await getCompliancebyUser(
        fullSelectedData.userid
      );

      // else if (amlRule == "2") {
      //   transactionAuditData = await TransactionAuditManyToOne(manyToOneParam);
      // } else if (amlRule == "3") {
      //   transactionAuditData = await TransactionAuditCities();
      // }
      if (transactionAuditData.data) {
        if (transactionAuditData.data.record.length != undefined) {
          setTransactionAuditData(transactionAuditData.data.record);
          setHasData(true);
        } else {
          setTransactionAuditData([transactionAuditData.data.record]);
          setHasData(true);
        }
      } else {
        setTransactionAuditData([{ transactionaudit: fullSelectedData }]);
        setHasData(true);
      }

      setLoading(false);
    };
    getData();
  }, []);

  const getParsedData = (data) => {
    try {
      return JSON.parse(data.replace(/&quot;/g, '"')).record;
    } catch (e) {
      console.error("Error parsing data:", e);
      return {};
    }
  };

  //Printing a CSV is done below
  // Add your title here
  const titleRow = [
    `Transaction Report for ${fullSelectedData.amruledesc} - ${selectedData.senderFirstName} ${selectedData.senderLastname}`,
  ];
  //function written to give total amount from filtered results

  const csvData = [
    // Add the title row as the first row
    titleRow,
    // Add an empty row to separate the title from the header
    [],
    // These will be header columns
    [
      "Reference No.",
      "Face Amount(R)",
      "Sender Local Currency Amount",
      "Sender Local Currency Code",
      "Send Date",
      "Sender First Name",
      "Sender Middle Name",
      "Sender Last Name",
      "Sender Maternal Name",
      "Sender Address1",
      "Sender Address2",
      "Sender Address3",
      "Sender City",
      "Sender Province",
      "Sender Country",
      "Sender Phone Number",
      "Birth Date",
      "Photo Id",
      "Photo Id Type",
      "Receiver First Name",
      "Receiver Last Name",
      "Sender Agent Name",
      "Sender Agent Country",
      "Receiver Agent Country",
      "Occupation",
      "Purpose Of Transaction",
      "Source Of Funds",
      "Relationship With Receiver",
      "Current Transaction Status",
    ],
    // Add the data rows
    ...transactionAuditData.map((row) => {
      const parsedData = getParsedData(row.transactionaudit.sourcedata);

      return [
        parsedData.ReferenceNumber,
        parsedData.faceAmount,
        parsedData.senderLocalCurrencyAmount,
        parsedData.senderLocalCurrencyCode,
        parsedData.sendDate,
        parsedData.senderFirstName,
        parsedData.senderMiddleName,
        parsedData.senderLastname,
        parsedData.senderMaternalName,
        parsedData.senderAddress1,
        parsedData.senderAddress2,
        parsedData.senderAddress3,
        parsedData.senderCity,
        parsedData.senderProvince,
        parsedData.senderCountry,
        parsedData.senderPhoneNumber,
        parsedData.BirthDate,
        parsedData.photoID,
        parsedData.photoIDType,
        parsedData.receiverFirstName,
        parsedData.receiverLastName,
        parsedData.senderAgentName,
        parsedData.senderAgentCountry,
        parsedData.receiverAgentCountry,
        parsedData.occupation,
        parsedData.purposeOfTransaction,
        parsedData.sourceOfFunds,
        parsedData.relationshipWithReceiver,
        parsedData.currenctTransactionStatus,
      ];
    }),
    // [
    //   `Total Records ${filteredData.length}`,
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   `Total Amount: ${totalCSVAmount}`,
    //   `Total Fees: ${totalFeeAmount.toFixed(2)}`,
    // ],
  ];

  const getRulesIcon = (amlRules) => {
    var rulesArray = amlRules.split(",");

    return rulesArray[0];
  };

  return (
    <>
      {loading ? (
        <>loading...</>
      ) : (
        <>
          <CSVLink
            data={csvData}
            filename={`SendIt-Audit-Report-${selectedData.senderFirstName} ${selectedData.senderLastname}.csv`}
          >
            <img src={CSVImage} className="csv-image-download mb-3 mt-3" />
          </CSVLink>
          <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
            <Table
              sx={{ minWidth: 500 }}
              aria-label="sticky table"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ position: "sticky", top: 0 }}>
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Date Sent</p>
                      {sorting.column === "date" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Sender</p>
                      {sorting.column === "receivingAddress" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">DOB</p>
                      {sorting.column === "type" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>

                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">
                        Sender Country
                      </p>
                      {sorting.column === "status" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">
                        Sender Currency
                      </p>
                      {sorting.column === "transactionId" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Sender Agent</p>
                      {sorting.column === "userName" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Recipient</p>
                      {sorting.column === "fee" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">
                        Recipient Country
                      </p>
                      {sorting.column === "amount" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Reference No.</p>
                      {sorting.column === "amount" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">
                        Recipient Occupation
                      </p>
                      {sorting.column === "amount" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Purpose</p>
                      {sorting.column === "amount" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Amount</p>
                      {sorting.column === "amount" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Audit</p>
                      {sorting.column === "amount" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactionAuditData.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 150 }}
                    >
                      <p className="transaction-table-date">
                        {row.transactionaudit.datetime}
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <div className="transaction-table-address-container">
                        <p className="transaction-table-address">
                          {row.transactionaudit.userid}
                        </p>
                      </div>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.BirthDate
                        }

                        {/* {
                            JSON.parse(
                              row.transactionaudit.sourcedata.replace(
                                /&quot;/g,
                                '"'
                              )
                            ).record.currentTransactionStatus
                          } */}
                      </p>
                    </TableCell>

                    <TableCell style={{ width: 110 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderCountry
                        }

                        {/* {row.status == "completed" ? (
                          <img src={Check} />
                        ) : row.status == "pending" ? (
                          <img src={Pending} />
                        ) : (
                          <img src={Cancelled} />
                        )} */}
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 120 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderLocalCurrencyCode
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 120 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderAgentName
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.receiverFirstName
                        }{" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.receiverLastName
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 130 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.receiverAgentCountry
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 130 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.ReferenceNumber
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.occupation
                          //).record.relationshipWithReceiver
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {(() => {
                          const sourcedata = JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record;

                          const purposeOfTransaction =
                            sourcedata.purposeOfTransaction;

                          if (Array.isArray(purposeOfTransaction)) {
                            // If purposeOfTransaction is an array, join the values with a comma
                            return purposeOfTransaction.join(", ");
                          } else {
                            // If purposeOfTransaction is a single value, display it as is
                            return purposeOfTransaction;
                          }
                        })()}
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderLocalCurrencyAmount
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 120 }} align="left">
                      <p className="transaction-table-date">
                        {getRulesIcon(row.transactionaudit.amlrule) != "0" ? (
                          <img
                            src={Warningsign}
                            className="pointer"
                            title={row.transactionaudit.amruledesc}
                            onClick={() =>
                              setSelectedData(
                                JSON.parse(
                                  row.transactionaudit.sourcedata.replace(
                                    /&quot;/g,
                                    '"'
                                  )
                                ).record,
                                row.transactionaudit
                              )
                            }
                          />
                        ) : (
                          <img src={Check} />
                        )}{" "}
                        {/* {getRules(row.transactionaudit.amlrule)} */}
                      </p>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </>
  );
}
